import { render } from "./QuestionsMain.vue?vue&type=template&id=2474e0a6"
import script from "./QuestionsMain.vue?vue&type=script&lang=js"
export * from "./QuestionsMain.vue?vue&type=script&lang=js"

import "./QuestionsMain.vue?vue&type=style&index=0&id=2474e0a6&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__